import "./login.scss";
import Logo from "../assets/images/log.png";
import Form from "react-bootstrap/Form";
import { PostData, URL } from "../hooks/fetchdata";
import { useState } from "react";
import { useUserContext } from "../contexts/users-context";
import { BounceLoader } from "react-spinners";
import { data, region } from "../data/data";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import { Link } from 'react-router-dom';
import googleIcon from '../assets/images/login/googleIcon.png';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

const Signup = () => {
  const { token, setLoading, loading } = useUserContext();

  // Yangi state'lar qo'shildi
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [cityId, setCityId] = useState(null);
  const [provinceId, setProvinceId] = useState(null);
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedProvince, setSelectedProvince] = useState('');
  const [userType, setUserType] = useState(null);
  const [you, setYou] = useState('');
  const [you2, setYou2] = useState('');
  const [error, setError] = useState('');
  const { setToken } = useUserContext();
  const [user, setUser] = useState(null);
  const [idToken, setIdToken] = useState('')
  const [errorPhone, setErrorPhone] = useState(false)
  const [importantPhone, setImportantPhone] = useState(false)
  const navigate = useNavigate();

  // telefonni formatlash
  const formatUzPhone = (input) => {
    const digits = input.replace(/\D/g, "");
    if (!digits.startsWith("998")) return "+998";

    let out = "+998 ";
    if (digits.length > 3) out += "(" + digits.slice(3, 5);
    if (digits.length > 5) out += ")-" + digits.slice(5, 8);
    if (digits.length > 8) out += "-" + digits.slice(8, 10);
    if (digits.length > 10) out += "-" + digits.slice(10, 12);

    return out.trim();
  };

  const handlePhoneChange = (e) => {
    const formatted = formatUzPhone(e.target.value);
    setPhone(formatted);
  };

  const handlePhoneKeyDown = (e) => {
    if (e.key === 'Backspace' && phone.length <= 5) {
      e.preventDefault();
    }
  };

  function formatDate(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const day = ("0" + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }


  const reformatUzPhone = (input) => {
    // Faqat raqamlarni qoldiramiz
    let digits = input.replace(/\D/g, "");

    // Agar 998 bilan boshlanmasa majburlab qo‘yamiz
    if (!digits.startsWith("998")) {
      digits = "998" + digits.replace(/^998/, "");
    }

    // Maksimal 12 ta raqam (998 + 9 ta raqam)
    digits = digits.slice(0, 12);

    return "+" + digits;
  };



  const submitPhoneHandler = async (e) => {
    e.preventDefault();
    if (reformatUzPhone(phone).length <= 12) {
      setError('Telefon raqamni kiriting!');
      setErrorPhone(true)
      return;
    }
    else {
      try {
        const res = await fetch(`${URL}/api/auth/google/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id_token: idToken,
            phone: reformatUzPhone(phone),
          }),
        });

        const data = await res.json();
        if (res.ok) {
          localStorage.setItem('accessToken', data.tokens.access);
          localStorage.setItem('refreshToken', data.tokens.refresh);
          setToken(data.tokens.access);
          setUser(data.user);
          navigate('/');
        } else {
          setError(data.error || 'Phone submit failed');
        }
      } catch (err) {
        setError(error.data.error);
        console.log(error.data);

      }
    }
  };

  const SubmitHandler = async (e) => {
    e.preventDefault();
    if (reformatUzPhone(phone).length <= 12) {
      setError('Telefon raqamni kiriting!');
      setErrorPhone(true)
      return;
    }
    else {

      setLoading(true);

      try {
        setErrorPhone(false)
        const formattedDateOfBirth = formatDate(dateOfBirth);

        let city = region?.find((e) => e.id === cityId);
        let province = data?.find((e) => e.id === provinceId);

        if (password !== password2) {
          setError("Parollar mos emas");
          setLoading(false);
          return;
        }

        const userData = {
          phone: reformatUzPhone(phone).trim(),
          email: email,
          password: password,
          password2: password2,
          first_name: firstName,
          last_name: lastName,
          middle_name: middleName,
          birth_date: formattedDateOfBirth,
          region: province?.name_uz || selectedProvince,
          city: city?.name_uz || selectedCity,
          user_type: you === "other" ? you2 : you,
        };
        console.log(userData);

        const response = await fetch(`${URL}/api/auth/register/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(userData),
        });

        const result = await response.json();

        if (!response.ok) {
          setError(result);
          setLoading(false);
          return;
        }

        const accessToken = result.tokens.access;

        localStorage.setItem('accessToken', accessToken);
        setToken(accessToken);

        setLoading(false);
        navigate('/');


      } catch (err) {
        setLoading(false);
        console.log(err);
        setError(err);
      }
    }
  };

  const onSuccess = async (response) => {
    try {
      const id_token = response.credential;
      console.log('Google ID token:', id_token);
      setIdToken(id_token)
      const res = await fetch(`${URL}/api/auth/google/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id_token }),
      });

      const data = await res.json();
      console.log('Backend response:', data);

      if (res.ok) {
        // Agar backend OK bo'lsa, token va user saqlash
        const accessToken = data.tokens.access;
        const refreshToken = data.tokens.refresh;

        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        setToken(accessToken);
        setUser(data.user);
        navigate('/');
      } else {
        if (data.error === "Birinchi marta Google bilan ro'yxatdan o'tishda phone majburiy!") {
          setError(data.error);
          setImportantPhone(true)
        } else {
          setError(data.error || 'Google login failed.');
        }
      }
    } catch (err) {
      console.error('Google login error:', err);
      setError('Google login failed. Try again.');
    }
  };
  const fieldNames = {
    phone: "Telefon raqam",
    email: "Email",
    user_type: "Foydalanuvchi turi"
  };

  const formatError = (field, message) => {
    if (message.includes("already exists")) {
      return `${fieldNames[field]} allaqachon mavjud`;
    }

    if (message.includes("valid UUID")) {
      return `${fieldNames[field]} noto‘g‘ri tanlangan`;
    }

    return message;
  };

  const onFailure = (error) => {
    console.log('Login Failed:', error);
  };
  console.log(error);

  return (
    <>
      {loading && (
        <div className="loader-wrapper">
          <BounceLoader color="#36d7b7" size={60} />
        </div>
      )}
      {importantPhone ?
        <div className="log" >
          <Form onSubmit={submitPhoneHandler} className='signup-container login loginm w-md-30' style={{ boxShadow: '2px 1px 20px' }}>
            <Form.Group className="mb-3 z-50">
              <Form.Label>Telefon raqamingizni kirting</Form.Label>
              <Form.Control
                type="tel"
                required
                value={phone}
                onChange={handlePhoneChange}
                onKeyDown={handlePhoneKeyDown}
                placeholder="+998 90 123 45 67"
              />
            </Form.Group>
            {error && <div className="text">{error}</div>}
            <button className="primary-button" variant="primary" type="submit" style={{ marginBottom: 0 }}>
              Kirish
            </button>
          </Form>
        </div>
        :
        <div className="signup-wrapper">
          <div className="signup-container">
            <Link to="/" className="logo-container">
              <img src={Logo} alt="Logo" className="logo" />
            </Link>

            <Form onSubmit={SubmitHandler} className="signup-form">
              <div className="form-grid">
                {/* Ism */}
                <Form.Group className="form-group">
                  <Form.Label>Ism <span className="required">*</span></Form.Label>
                  <Form.Control
                    required
                    onChange={(e) => setFirstName(e.target.value)}
                    type="text"
                    placeholder="Ismingizni kiriting"
                    value={firstName}
                  />
                </Form.Group>

                {/* Familiya */}
                <Form.Group className="form-group">
                  <Form.Label>Familiya <span className="required">*</span></Form.Label>
                  <Form.Control
                    required
                    onChange={(e) => setLastName(e.target.value)}
                    type="text"
                    placeholder="Familiyangizni kiriting"
                    value={lastName}
                  />
                </Form.Group>

                {/* Otasini ismi */}
                <Form.Group className="form-group">
                  <Form.Label>Otasini ismi <span className="required">*</span></Form.Label>
                  <Form.Control
                    required
                    onChange={(e) => setMiddleName(e.target.value)}
                    type="text"
                    placeholder="Otasining ismini kiriting"
                    value={middleName}
                  />
                </Form.Group>

                {/* Email */}
                <Form.Group className="form-group">
                  <Form.Label>Email <span className="required">*</span></Form.Label>
                  <Form.Control
                    required
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="test@example.com"
                    value={email}
                  />
                </Form.Group>

                {/* Telefon raqami */}
                <Form.Group className="mb-3">
                  <Form.Label>Telefon raqami</Form.Label>
                  <Form.Control
                    type="tel"
                    value={phone}
                    onChange={handlePhoneChange}
                    onKeyDown={handlePhoneKeyDown}
                    placeholder="+998 90 123 45 67"
                  />
                  {errorPhone && <div className="text-danger">telefon nomerni kiritish shart!!!</div>}
                </Form.Group>

                {/* Tug'ilgan kun */}
                <Form.Group className="form-group">
                  <Form.Label>Tug'ilgan kun <span className="required">*</span></Form.Label>
                  <Form.Control
                    required
                    onChange={(e) => setDateOfBirth(e.target.value)}
                    type="date"
                    value={dateOfBirth}
                  />
                </Form.Group>

                {/* Viloyat */}
                <Form.Group className="form-group">
                  <Form.Label>Viloyat <span className="required">*</span></Form.Label>
                  <Form.Select
                    required
                    onChange={(e) => {
                      setProvinceId(parseInt(e.target.value));
                      setSelectedProvince(e.target.options[e.target.selectedIndex].text);
                    }}
                    value={provinceId || ''}
                  >
                    <option value="">Viloyatni tanlang</option>
                    {region?.map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.name_uz}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                {/* Shahar/Tuman */}
                <Form.Group className="form-group">
                  <Form.Label>Shahar/Tuman <span className="required">*</span></Form.Label>
                  <Form.Select
                    required
                    onChange={(e) => {
                      setCityId(parseInt(e.target.value));
                      setSelectedCity(e.target.options[e.target.selectedIndex].text);
                    }}
                    value={cityId || ''}
                    disabled={!provinceId}
                  >
                    <option value="">Shahar/Tumanni tanlang</option>
                    {data?.filter(item => item.region_id === provinceId).map((e) => (
                      <option key={e.id} value={e.id}>
                        {e.name_uz}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                {/* Foydalanuvchi turi */}
                <Form.Group className="form-group full-width">
                  <Form.Label>Siz kimsiniz?</Form.Label>
                  {you !== "other" ? (
                    <Form.Select
                      onChange={(e) => {
                        setYou(e.target.value);
                        setUserType(e.target.value);
                      }}
                      value={you}
                      required
                    >
                      <option value="">Tanlang</option>
                      <option value="teacher">O'qituvchi</option>
                      <option value="student">Talaba</option>
                      <option value="pupil">O'quvchi</option>
                      <option value="jurnalist">Jurnalist</option>
                      <option value="ecofaol">Eco faol</option>
                      <option value="volunteer">Volontyor</option>
                      <option value="worker">Ishchi xodim</option>
                      <option value="other">Boshqa</option>
                    </Form.Select>
                  ) : (
                    <Form.Control
                      required
                      onChange={(e) => {
                        setYou2(e.target.value);
                        setUserType(e.target.value);
                      }}
                      type="text"
                      placeholder="Kasbingizni kiriting"
                      value={you2}
                    />
                  )}
                </Form.Group>

                {/* Parol */}
                <Form.Group className="form-group">
                  <Form.Label>
                    Parol <span className="required">*</span>
                  </Form.Label>
                  <Form.Control
                    required
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    placeholder="Parolni kiriting"
                    value={password}
                  />
                </Form.Group>

                {/* Parolni takrorlash */}
                <Form.Group className="form-group">
                  <Form.Label>Parolni takrorlang <span className="required">*</span></Form.Label>
                  <Form.Control
                    required
                    onChange={(e) => setPassword2(e.target.value)}
                    type="password"
                    placeholder="Parolni qayta kiriting"
                    value={password2}
                  />
                </Form.Group>
              </div>
              {error && Object.entries(error).map(([field, messages]) =>
                messages.map((msg, index) => (
                  <div key={field + index} className="alert alert-danger py-2 px-3 mt-2">
                    {formatError(field, msg)}
                  </div>
                ))
              )}

              <div className="form-actions">
                <Button
                  variant="dark"
                  type="submit"
                  className="primary-button"
                  disabled={loading}
                >
                  {loading ? "Yuborilmoqda..." : "Ro'yxatdan o'tish"}
                </Button>

                <div className="mt-4">
                  Akkountingiz bormi? <Link to="/login">Kirish</Link>
                </div>
              </div>
            </Form>

            <div className="other-login">
              <div className="divider">
                <span className="line"></span>
                <span className="or-text">yoki</span>
                <span className="line"></span>
              </div>

              <GoogleLogin
                className="google-btn"
                onSuccess={onSuccess}
                onFailure={onFailure}
                text="signup_with"
                shape="rectangular"
              />
            </div>
          </div>
        </div>}
    </>
  );
};

export default Signup;